/* global window */
'use strict';

import App from './app.jsx';
import ReactDOM from 'react-dom';


class Page {
    static blastoff() {

        this.mainElement = ReactDOM.render(
            App,
            window.document.getElementById('app-mount')
        );
    }
}


export default Page;


/* $lab:coverage:off$ */
if (!module.parent) {
    window.page = Page;
    Page.blastoff();
}
/* $lab:coverage:on$ */
